
import {
    GET_DATA_MODEL_DEFINITION_ACTION_TYPE
} from '../sagas/getDataModelDefinition';

import { LOGOUT_ACTION_TYPE } from '../../common/client/sagas/auth';

const initialState = {
    initialized: false,
    loading: false,
    dataModelDefinition: null
};

export function getDataModelItem(state, itemId) {
    return state.dataModelDefinition
        ? state.dataModelDefinition.items.reduce((previous, current) => {
                return (current.id === itemId)
                    ? current
                    : previous;
            }, null)
        : null;
}

function dataModelDefinition(state = initialState, action) {
    switch (action.type) {
        case GET_DATA_MODEL_DEFINITION_ACTION_TYPE.LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_DATA_MODEL_DEFINITION_ACTION_TYPE.SUCCESS:
            return {
                ...state,
                dataModelDefinition: action.dataModelDefinition,
                loading: false
            };
        case GET_DATA_MODEL_DEFINITION_ACTION_TYPE.FAILED:
            return {
                ...state,
                dataModelDefinition: null,
                loading: false
            };

        case LOGOUT_ACTION_TYPE.SUCCESS:
            return {
                ...initialState
            };

        default:
            return state;
    }
}

export default dataModelDefinition;
